import React, { PureComponent } from 'react'
import GridItem from './GridItem'
import getBackgroundPosterObj from '../functions/getBackgroundPosterObj'

class PosterGrid extends PureComponent {
    constructor(props) {
        super(props)
    }

    getPosterObj(itemId) {
        const { movies } = this.props

        const item = movies[itemId]   
        return item.hasOwnProperty('images') ? getBackgroundPosterObj(item.images) : false  

    }

    render() {
        const { movies, moviesOrder, isMobile } = this.props
       
        let poster = _.without(moviesOrder.map((itemId, index) => { 
            const poster =this.getPosterObj(itemId)

            if(poster) {
                return (
                    <GridItem
                        key={index}
                        isMobile={isMobile}
                        poster={poster}
                    /> 
                )
            } else return false
        }), false)
        
        let posters = []
        let posterIndex = 1

        if(poster.length > 0 && poster.length < 45) {
            while(posters.length < 45) {
                moviesOrder.map((itemId, i) => {
                    const poster =this.getPosterObj(itemId)

                    if(poster) {                 
                        posters.push(
                            <GridItem
                                key={posterIndex}
                                isMobile={isMobile}
                                poster={poster}
                            />
                        )
                        posterIndex++
                    }
                })
            }
        } else {
            posters.push(poster)
        }
        
        const sortedPosters = posters.sort(function (a, b) {return Math.random() - 0.5;})

        return (
            <div className="poster-grid">
                <div className="poster-grid-wrapper">
                    {sortedPosters}
                </div>
                <div className="poster-gradient"></div>
            </div>
        )
    }
}


export default PosterGrid